import { render, staticRenderFns } from "./emailc.vue?vue&type=template&id=c12da818&scoped=true&"
import script from "./emailc.vue?vue&type=script&lang=js&"
export * from "./emailc.vue?vue&type=script&lang=js&"
import style0 from "./emailc.vue?vue&type=style&index=0&id=c12da818&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12da818",
  null
  
)

export default component.exports